import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IContractorServiceZip, IContractorServiceZipInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ContractorServiceZipApiService {

  abstract get (contactId: string) : Observable<IContractorServiceZip[]>;

  abstract save (contractServiceZip: IContractorServiceZipInput): Observable<IContractorServiceZip>;
  abstract delete(contractServiceZip: IContractorServiceZipInput): Observable<IContractorServiceZip>;

}
